import { z } from "zod";

/** Línea de detalle en un ticket (opcional, para notas o futuro desglose). */
export const receiptLineItemSchema = z.object({
  description: z.string(),
  quantity: z.number().finite().optional(),
  unitPriceMinor: z.number().int().optional(),
  lineTotalMinor: z.number().int().optional(),
});

/**
 * Datos estructurados devueltos por el extractor (Gemini) y guardados en `receipt_scan.extracted_payload`.
 * Alineado con alta de gasto: importe menor, moneda, fecha, título sugerido (comercio), categoría, notas.
 */
export const receiptExtractedPayloadSchema = z.object({
  merchant: z.string().nullable().optional(),
  /** Fecha del gasto en calendario local del ticket, formato YYYY-MM-DD */
  occurredOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  totalAmountMinor: z.number().int().nullable().optional(),
  /** ISO 4217, 3 letras mayúsculas */
  currency: z
    .string()
    .length(3)
    .regex(/^[A-Z]{3}$/)
    .nullable()
    .optional(),
  suggestedCategoryName: z.string().nullable().optional(),
  suggestedCategorySlug: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  lineItems: z.array(receiptLineItemSchema).optional(),
  confidence: z.number().min(0).max(1).nullable().optional(),
});

export type ReceiptLineItem = z.infer<typeof receiptLineItemSchema>;
export type ReceiptExtractedPayload = z.infer<typeof receiptExtractedPayloadSchema>;

export const receiptExtractionErrorPayloadSchema = z.object({
  extractionError: z.object({
    key: z.string(),
  }),
});

export type ReceiptExtractionErrorPayload = z.infer<typeof receiptExtractionErrorPayloadSchema>;

export function isReceiptExtractionErrorPayload(
  value: unknown,
): value is ReceiptExtractionErrorPayload {
  return receiptExtractionErrorPayloadSchema.safeParse(value).success;
}

export function parseReceiptExtractedPayload(raw: unknown): ReceiptExtractedPayload | null {
  const parsed = receiptExtractedPayloadSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
